import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'
import { pspResponseData } from './psp'
import { FormattedAddressData, UnformattedAddressData } from '../ips/address'
extendZodWithOpenApi(z)

// Card Details Schema
export const cardDetails = z.object({
    lastFourDigits: z.string().min(4).max(4),
    expiryMonth: z.number().min(1).max(12),
    expiryYear: z.string().regex(/^\d{4}$/, 'expiryYear must be 4 digits'),
    bin: z.string().max(8),
})

export const achDetailsSchema = z.object({
    accountNo: z.string().min(8).max(12),
    accountHolderName: z
        .string()
        .max(50)
        .describe(
            'For now, this must be assumed to be the same full name as the person, we do not provide a way to override this in the UI. Although you can pass any name value you like in the SDK.',
        ),
    accountType: z.string().max(20).optional().default('CHECKING'),
    routingNumber: z.string().max(10),
})

// Bank or Card Billing Schema
export const achOrCardBillingSchema = z.discriminatedUnion('type', [
    achDetailsSchema.extend({
        type: z.literal('ach'),
    }),
    cardDetails.extend({
        type: z.literal('card'),
    }),
])

export const addressSchema = z.discriminatedUnion('type', [
    FormattedAddressData,
    UnformattedAddressData,
])
const billingAccountId = z
    .string()
    .openapi({ example: '50605d6c-22b0-4b94-b38b-95ef2c52f42a' })
    .describe('Billing account ID returned from IPS POST Billing endpoint')

// Existing Billing Schema
export const existingBilling = z.object({
    type: z.literal('existingBilling'),
    billingAccountId,
    billingProfileId: z
        .string()
        .openapi({ example: '50605d6c-22b0-4b94-b38b-95ef2c52f42a' })
        .describe('Profile id returned from IPS PUT billing endpoint'),
})

// New Billing Schema
export const newBillingSchema = z.object({
    type: z.literal('newBilling'),
    billingAccountId,
    billingDetails: cardDetails
        .extend({
            type: z.literal('card'),
        })
        .and(
            pspResponseData.pick({
                pspId: true,
                pspProfileId: true,
                pspToken: true,
            }),
        ),
})

export type NewBillingSchema = z.infer<typeof newBillingSchema>
